import type { MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'
import type { MicCheckIssue } from './micCheckAnalysis'

export const DEFAULT_PROMPT = msg`The quiet morning birds call from the old oak tree.`

export const ISSUE_MESSAGES: Record<NonNullable<MicCheckIssue>, { title: MessageDescriptor; fix: MessageDescriptor }> = {
  'no-voice': {
    title: msg`We didn't hear you`,
    fix: msg`Make sure you're speaking the sentence out loud. Check that the right mic is selected below.`
  },
  clip: {
    title: msg`A bit too loud`,
    fix: msg`Move the mic about a hand's-width from your mouth, or speak a touch softer.`
  },
  quiet: {
    title: msg`You sound far away`,
    fix: msg`Move closer to your mic — 15–20 cm is ideal — or raise input gain in system settings.`
  },
  noise: {
    title: msg`Background noise is high`,
    fix: msg`We hear hum or traffic behind your voice. Turn off fans or AC, or move to a quieter room.`
  },
  'no-signal': {
    title: msg`No sound from your microphone`,
    fix: msg`If you opened this inside another app, open it in Chrome or Safari, then try again.`
  }
}
